<template>
  <slot></slot>
</template>

<script setup>
import {computed, provide} from "vue"

const props = defineProps(['modelValue'])
const emit = defineEmits(['update:modelValue'])

const currentValue = computed({
  get() {
    return props.modelValue
  },
  set(v) {
    emit('update:modelValue', v)
  }
})

provide('currentValue', currentValue)
provide('onChange', (val) => {
  currentValue.value = val
})
</script>
